<!-- Gallery Section -->
<div class="py-5"></div>
<section class="gallery-section py-5">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="fw-bold fs-3 heading-text-color">Gallery</div><div class="text-shadow-effect">Gallery</div>
    </div>
    
<!-- Tabs -->
<div class="tabs">
  <div 
    class="tab" 
    [class.active]="selectedCategory === 'All'" 
    (click)="selectCategory('All')">
    All
  </div>

  <div 
    class="tab" 
    *ngFor="let cat of categories"
    [class.active]="selectedCategory === cat" 
    (click)="selectCategory(cat)">
    {{ cat }}
  </div>
</div>

<!-- Gallery -->
 <div class="row">
    <div class="col-md-3 col-sm-6 mb-4" *ngFor="let item of filteredImages" (click)="openModal(item)" tabindex="0" (keydown.enter)="openModal(item)">
        <div class="gallery-item">
          <img [src]="item.url" [alt]="item.category" class="img-fluid zoom-img">
          <div class="gallery-overlay">
            <h6 class="gallery-title">{{item.category}}</h6>
          </div>
        </div>
      </div>

</div>
  </div>
</section>
<!-- Bootstrap Modal -->
<div
  class="modal fade"
  id="imageModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg-light">
      <!-- Close button (top-right) -->
      <div class="modal-body text-center">
        <img
          [src]="selectedImage?.url"
          [alt]="selectedImage?.category"
          class="img-fluid zoomable"
        />
        <div class="text-dark mt-2" >{{ selectedImage?.category }}</div>
        
      </div>
      <div class="top-0" style="margin-left: 10px; cursor: pointer;" (click)="closeMyModal()">Close</div>
    </div>
  </div>
</div>